// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3ixab","gfeWrapper":"CalendarEvent_gfeWrapper__gTR_W"};